import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button, Row, Col, Alert } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { find as _find, indexOf as _indexOf } from 'lodash';

// import { getCalculatedHoldingCompanyInfos } from 'helpers/clients';

import RoundImage from 'components/layout/RoundImage';

class ClientGrantedHoldingAccessForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      type: 'single',
    };
  }

  componentDidUpdate = prevProps => {
    const { gratendHoldingAccessUsername } = this.props;

    if (prevProps.gratendHoldingAccessUsername !== gratendHoldingAccessUsername) {
      this.setState({
        type: 'single',
      });
    }
  };

  changeType = e => {
    const {
      target: { name, value: type },
    } = e;

    this.setState({ [name]: type });
  };

  formSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    const {
      holdingInfos: {
        data: { whitelist, blacklist },
      },
      grantedHoldingAccessAction,
      gratendHoldingAccessUsername,
      newGrantedHoldingAccess,
      newGrantedHoldingAccessDepth,
      onSubmit,
    } = this.props;
    const { type } = this.state;

    const isWhitelisted = _indexOf(whitelist, gratendHoldingAccessUsername) >= 0;
    const isBlacklisted = _indexOf(blacklist, gratendHoldingAccessUsername) >= 0;

    switch (type) {
      case 'single': {
        if (grantedHoldingAccessAction === 'grant') {
          if (isBlacklisted) {
            onSubmit({ removeFromBlacklist: gratendHoldingAccessUsername });
          } else {
            onSubmit({ addToWhitelist: gratendHoldingAccessUsername });
          }
        } else if (grantedHoldingAccessAction === 'deny') {
          if (isWhitelisted) {
            onSubmit({ removeFromWhitelist: gratendHoldingAccessUsername });
          } else {
            onSubmit({ addToBlacklist: gratendHoldingAccessUsername });
          }
        }
        break;
      }

      case 'tree': {
        onSubmit({
          grantedHoldingAccess: newGrantedHoldingAccess,
          grantedHoldingAccessDepth: newGrantedHoldingAccessDepth,
        });
        break;
      }
    }
  };

  close = () => {
    const { close } = this.props;
    if (close) {
      close();
    }
  };

  render() {
    const {
      intl: { messages },
      formStatus,
      grantedHoldingAccessAction,
      gratendHoldingAccessUsername,
      newGrantedHoldingAccess,
      newGrantedHoldingAccessDepth,
      holdingInfos: {
        data: {
          ancestors,
          siblings,
          descendants,
          current_granted_holding_access: grantedHoldingAccess,
          current_granted_holding_access_depth: grantedHoldingAccessDepth,
        },
      },
    } = this.props;
    const { type } = this.state;

    // fetch parent data from holdingInfos
    let holdingCompanyData = null;
    let holdingCompanyComponent = null;
    if (gratendHoldingAccessUsername) {
      holdingCompanyData = _find(ancestors, { id: gratendHoldingAccessUsername });
      if (!holdingCompanyData) {
        holdingCompanyData = _find(siblings, { id: gratendHoldingAccessUsername });
      }
      if (!holdingCompanyData) {
        holdingCompanyData = _find(descendants, { id: gratendHoldingAccessUsername });
      }
    }
    if (holdingCompanyData) {
      holdingCompanyComponent = (
        <div className="p-l-40">
          <div className="p-t-15">
            <div className="relative">
              <div className="top-left">
                {holdingCompanyData.avatar ? (
                  <RoundImage size={33} url={holdingCompanyData.avatar} usePixels />
                ) : (
                  <span className="fa-stack fa-lg" style={{ fontSize: '16.5px' }}>
                    <i className="fa fa-circle fa-stack-2x hint-text" />
                    <i className="fa fa-address-book fa-stack-1x fa-inverse" />
                  </span>
                )}
              </div>

              <div className={'m-l-40 ' + (holdingCompanyData.length ? 'm-r-30' : '')}>
                <div className="bold overflow-ellipsis">{holdingCompanyData.company}</div>
                <div className="small hint-text">ID: {holdingCompanyData.id}</div>
              </div>
            </div>
          </div>
          <div className="p-t-10 p-b-15">
            {holdingCompanyData.street} {holdingCompanyData.house_number} {holdingCompanyData.apartment_number}
            <br />
            {holdingCompanyData.zip_code} {holdingCompanyData.city}
          </div>
        </div>
      );
    }

    const treeTypeDisabled =
      newGrantedHoldingAccess === grantedHoldingAccess && newGrantedHoldingAccessDepth === grantedHoldingAccessDepth;

    return (
      <Row>
        <Col xs={12}>
          {grantedHoldingAccessAction === 'grant' && (
            <>
              <h4>{messages.grant_data_access}</h4>

              <div className={`${type === 'single' ? 'bg-master-lightest' : ''} padding-25 b-rad-lg m-b-15`}>
                <div className="radio radio-success">
                  <input
                    type="radio"
                    value="single"
                    name="type"
                    id="grantTypeSingle"
                    checked={type === 'single'}
                    onChange={this.changeType}
                    disabled={formStatus.pending}
                  />
                  <label for="grantTypeSingle">{messages.allow_data_access_for_a_single_company}</label>
                </div>
                {holdingCompanyComponent}
              </div>

              <div className={`${type === 'tree' ? 'bg-master-lightest' : ''} padding-25 b-rad-lg`}>
                <div className="radio radio-success">
                  <input
                    type="radio"
                    value="tree"
                    name="type"
                    id="grantTypeTree"
                    checked={type === 'tree'}
                    onChange={this.changeType}
                    disabled={formStatus.pending || treeTypeDisabled}
                  />
                  <label for="grantTypeTree">{messages.allow_data_access_for_a_whole_level}</label>
                </div>
              </div>
            </>
          )}
          {grantedHoldingAccessAction === 'deny' && (
            <>
              <h4>{messages.deny_data_access}</h4>

              <div className={`${type === 'single' ? 'bg-master-lightest' : ''} padding-25 b-rad-lg m-b-15`}>
                <div className="radio radio-success">
                  <input
                    type="radio"
                    value="single"
                    name="type"
                    id="grantTypeSingle"
                    checked={type === 'single'}
                    onChange={this.changeType}
                    disabled={formStatus.pending}
                  />
                  <label for="grantTypeSingle">{messages.deny_data_access_for_a_single_company}</label>
                </div>
                {holdingCompanyComponent}
              </div>

              <div className={`${type === 'tree' ? 'bg-master-lightest' : ''} padding-25 b-rad-lg`}>
                <div className="radio radio-success">
                  <input
                    type="radio"
                    value="tree"
                    name="type"
                    id="grantTypeTree"
                    checked={type === 'tree'}
                    onChange={this.changeType}
                    disabled={formStatus.pending || treeTypeDisabled}
                  />
                  <label for="grantTypeTree">{messages.deny_data_access_for_a_whole_level}</label>
                </div>
              </div>
            </>
          )}
          <form method="post" onSubmit={this.formSubmit}>
            <div className="panel panel-transparent">
              <div className="bg-master-lightest m-t-15 padding-25">
                <Alert bsStyle="danger" className="text-uppercase text-center">
                  {messages.confirm_action_ramifications}
                </Alert>

                <Row>
                  <Col xs={6} md={4} mdOffset={2}>
                    <Button block bsSize="lg" disabled={formStatus.pending} onClick={this.close}>
                      {messages.cancel}
                    </Button>
                  </Col>
                  <Col xs={6} md={4}>
                    <Button block bsSize="lg" type="submit" bsStyle="danger" disabled={formStatus.pending}>
                      <i className={'fa-fw ' + (formStatus.pending ? 'fa fa-circle-notch fa-spin' : 'fal fa-save')} />{' '}
                      {messages.save}
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          </form>
        </Col>

        <span className="small hint-text">
          {newGrantedHoldingAccess} {newGrantedHoldingAccessDepth} / {grantedHoldingAccess} {grantedHoldingAccessDepth}{' '}
          / {gratendHoldingAccessUsername}
        </span>
      </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    holdingInfos: state.data.holdingInfos,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(ClientGrantedHoldingAccessForm)));
